import FormInput from '../components/tuvi/FormInput'
import DiaBan from '../components/tuvi/DiaBan'
import LineMenh from '../components/tuvi/LineMenh'
import LineTuHoa from '../components/tuvi/LineTuHoa'
import { lapDiaBan } from '../utils/tuvi/app'
import { LapThienBan } from '../utils/tuvi/thienban'
import { CHI } from '../utils/calender'
import { CAC_LOAI_SAO } from '@/utils/tuvi/sao'
import { TreeSelect } from 'ant-design-vue'

export default {
  components: {
    FormInput,
    DiaBan,
    LineMenh,
    LineTuHoa
  },
  data () {
    return {
      TreeSelect,
      CHI,
      isModeTyping: true,
      name: 'Quang Thắng',
      birthday: '05/02/1996',
      tmpDay: 0,
      tmpMonth: 0,
      hour: 1,
      tmpHour: 1,
      tmpYear: 0,
      curYear: 2020,
      tmpCurYear: 2020,
      tmpTuHoaDv: null,
      tmpTuHoaTv: null,
      tmpTuHoa: [],
      gender: 1,
      type: 1,
      output: null,
      isShowTuHoaDv: false,
      isShowTuHoaTv: false,
      isShowTuHoaCp: false,
      isTuHoaIn: false,
      typeChuyenTuHoa: 0,
      tuHoaCung: {
        // type2: true,
        // type3: true,
        // type4: true,
        type1: true
      },
      isDenTrang: false,
      isShowStar: false,
      showStar: []
    }
  },
  watch: {
    isShowTuHoaCp (newVal) {
      if (newVal) {
        this.isDenTrang = true
      } else {
        this.isDenTrang = false
      }
    },
    isShowStar (newVal) {
      if (!newVal) {
        this.showStar = []
      }
    },
    curDaiVan (newVal) {
      this.tmpTuHoaDv = newVal
    },
    tmpCurYear (newVal, oldVal) {
      if (newVal !== oldVal) {
        const listTieuVan = this.listTieuVan.find((item) => item.year === Number(newVal), {})
        this.tmpTuHoaTv = listTieuVan ? listTieuVan.year + '_' + listTieuVan.cungSo : null
      }
    },
    tmpTuHoaDv (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.tmpTuHoaTv = this.listTieuVan[0].year + '_' + this.listTieuVan[0].cungSo
      }
    }
  },
  computed: {
    options () {
      return [
        { label: '14 Chính Tinh', value: 'muoiBonChinhTinhId' },
        { label: 'Tuần – Triệt', value: 'tuanTrietId' },
        { label: 'Lục Cát tinh', value: 'lucCatTinhId' },
        { label: 'Lục Sát tinh', value: 'lucSatTinhId' },
        { label: 'Tứ Hóa', value: 'tuHoaId' },
        { label: 'Vòng Trường Sinh', value: 'vongTruongSinhId' },
        { label: 'Sao Lưu', value: 'saoLuuId' },
        { label: 'Lộc - Mã', value: 'locMaId' },
        { label: 'Vòng Bác sĩ', value: 'vongBacSiId' },
        { label: 'Vòng Thái Tuế', value: 'vongThaiTueId' },
        { label: 'Thương Sứ La Võng', value: 'thuongSuLaVongId' },
        { label: 'Cái Hổ Phượng Long', value: 'caiHoPhuongLongId' },
        { label: 'Tứ Đức', value: 'tuDucId' },
        { label: 'Thọ Tài Quan Phúc', value: 'thoTaiQuanPhucId' },
        { label: 'Đào Hồng Không', value: 'daoHongKhongId' },
        { label: 'Đào Hồng Hỷ', value: 'daoHongHyId' },
        { label: 'Hình Sát Hà', value: 'hinhSatHaId' },
        { label: 'Cô Quả', value: 'coQuaId' },
        { label: 'Diêu Đà Kỵ', value: 'dieuDaKyId' },
        { label: 'Tang Hổ Khốc Hư', value: 'tangHoKhocHuId' },
        { label: 'Tam Thai Bát Toạ', value: 'tamThaiBatToa' },
        { label: 'Ân Quang Thiên Quý', value: 'anQuangThienQuy' },
        { label: 'Các sao còn lại', value: 'other' }
      ]
    },
    treeData () {
      let allSao = []
      if (this.diaBan && this.diaBan.thapNhiCung) {
        this.diaBan.thapNhiCung.forEach((cung) => {
          allSao = [
            ...allSao,
            ...cung.cungSao
          ]
        })
      }
      return this.options.map((item) => ({
        ...item,
        title: item.label,
        key: item.value,
        label: this.removeAccents(item.label),
        children: CAC_LOAI_SAO[item.value].map((saoID) => {
          const sao = allSao.find((sao) => sao.saoID === saoID)
          if (!sao) {
            return null
          }
          return {
            key: item.value + '_' + saoID,
            label: this.removeAccents(item.label) + ' ' + this.removeAccents(sao.saoTen),
            value: item.value + '_' + saoID,
            title: sao.saoTen
          }
        }).filter((sao) => sao)
      }
      ))
    },
    day () {
      return parseInt(this.tmpDay, 10) ?? parseInt(this.birthday.split('/')[0])
    },
    month () {
      return this.tmpMonth ? parseInt(this.tmpMonth, 10) : parseInt(this.birthday.split('/')[1])
    },
    year () {
      return this.tmpYear > 1000 && parseInt(this.tmpYear, 10) ? parseInt(this.tmpYear, 10) : parseInt(this.birthday.split('/')[2])
    },
    diaBan () {
      const diaBan = lapDiaBan(this.day, this.month, this.year, this.hour, this.gender, parseInt(this.curYear, 10), this.isShowTuHoaDv ? this.tmpTuHoaDv : null, this.isShowTuHoaTv ? this.tmpTuHoaTv : null)
      // console.log(diaBan)
      return diaBan
    },
    thienBan () {
      const thienBan = new LapThienBan(this.day, this.month, this.year, this.hour, this.gender, this.name, this.diaBan)
      return thienBan
    },
    thapNhiCung () {
      const thapNhiCung = this.diaBan.thapNhiCung.reduce((acc, cur) => {
        acc[cur.cungSo] = cur
        return acc
      }, {})
      // console.log(thapNhiCung)
      return thapNhiCung
    },
    cungMenh () {
      return this.diaBan.lineMenh
    },
    optionDaiVan () {
      const options = []
      Object.values(this.thapNhiCung)
        .sort((a, b) => (a.cungDaiHan > b.cungDaiHan) ? 1 : -1)
        .forEach((tnc) => {
          if (tnc.cungSo) {
            options.push({
              name: 'Đại Vận ' + tnc.cungDaiHan,
              cungSo: tnc.cungSo
            })
          }
        })
      return options
    },
    curDaiVan () {
      return this.diaBan.curSoDaiHan
    },
    initColor () {
      let color = ['red', 'black']
      switch (this.typeChuyenTuHoa) {
        case 1:
          color = ['black', 'black']
          break
        case 2:
          color = ['blue', 'green']
          break
        case 3:
          color = ['green', 'green']
          break
        case 0:
        default:
          color = ['red', 'black']
      }
      return color
    },
    pathTuHoa () {
      let pathTuHoa = this.diaBan.pathTuHoaLoc
      switch (this.typeChuyenTuHoa) {
        case 1:
          pathTuHoa = this.diaBan.pathTuHoaKy
          break
        case 2:
          pathTuHoa = this.diaBan.pathTuHoaQuyen
          break
        case 3:
          pathTuHoa = this.diaBan.pathTuHoaKhoa
          break
        default:
          pathTuHoa = this.diaBan.pathTuHoaLoc
      }
      const checkLineEnd = {}
      return pathTuHoa.filter((item) => {
        return item
        // const type = item[3]
        // return (this.tuHoaCung.type1 && type.includes(1)) ||
        //   (this.tuHoaCung.type2 && type.includes(2)) ||
        //   (this.tuHoaCung.type3 && type.includes(3)) ||
        //   (this.tuHoaCung.type4 && type.includes(4))
      }).map((item) => {
        const key = item[1] + '-' + item[2]
        if (!checkLineEnd[key]) {
          checkLineEnd[key] = true
        } else {
          return [item[0], item[1], null, item[3]]
        }
        return item
      })
    },
    curTieuVan () {
      const tuoi = this.tmpCurYear - this.thienBan.namAm + 1
      const listTieuVan = this.listTieuVan.find((item) => item.tuoi === tuoi)
      return listTieuVan?.cungSo || null
    },
    listTieuVan () {
      if (!this.tmpTuHoaDv) {
        return []
      }
      const dataDaiVan = this.thapNhiCung[this.tmpTuHoaDv]
      const amDuongNamNu = this.thienBan.amDuongNamNu
      const namSinh = this.thienBan.namAm
      let cungSo = dataDaiVan.cungSo
      const cungDaiHan = dataDaiVan.cungDaiHan
      return [...Array(10).keys()].map((key) => {
        const tuoi = cungDaiHan + key
        if (key === 1) {
          cungSo += 6
        } else if (key === 2) {
          cungSo = cungSo - amDuongNamNu
        } else if (key !== 0) {
          cungSo = cungSo + amDuongNamNu
        }
        if (cungSo > 12) {
          cungSo = cungSo % 12
        }
        return {
          key,
          tuoi,
          year: tuoi + namSinh - 1,
          cungSo
        }
      })
    }
  },
  methods: {
    setData ({ name, birthday, hour, curYear, gender, type }) {
      this.name = name
      this.birthday = birthday
      this.hour = hour
      this.gender = gender
      this.curYear = curYear
      this.tmpCurYear = curYear
      this.tmpHour = hour
      this.tmpDay = parseInt(birthday.split('/')[0], 10)
      this.tmpMonth = parseInt(birthday.split('/')[1], 10)
      this.tmpYear = parseInt(birthday.split('/')[2], 10)
      this.tmpTuHoaDv = this.curDaiVan
      this.tmpTuHoaTv = curYear + '_' + this.curTieuVan
      this.type = type
      this.print()
    },
    changeData () {
      this.curYear = parseInt(this.tmpCurYear, 10)
      this.hour = parseInt(this.tmpHour, 10)
      if (this.output) {
        this.print()
      }
    },
    removeAccents (str) {
      return str.normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/đ/g, 'd').replace(/Đ/g, 'D')
    }
  }
}
